import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Mantine 스타일 (누락 시 컴포넌트 무스타일 렌더)
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

// 폰트 (정적, weight별 — synthetic bold 방지)
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/geist-sans/300.css';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';

import './index.css';
import { Providers } from './app/providers';
import { AppRouter } from './app/router';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </StrictMode>,
);
